import * as React from "react";
import { cn } from "../../lib/utils";

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <textarea
            className={cn(
                "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus:ring-1 focus:ring-[#232946] disabled:cursor-not-allowed disabled:opacity-50",
                className
            )}
            ref__={ref}
            {...props}
        />
    );
});
Textarea.displayName = "Textarea";

export { Textarea };